import React from 'react';
import { Formik, Form, Field, FieldArray } from 'formik';
import { Grid, Box, Button, Divider } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { addFundAgentDispatch } from 'reducers/HomeReducer';

const AddFund = () => {
	const { agentId } = useSelector((state) => state.ui);
	const { loginInfo } = useSelector((state) => state.home);
	const dispatch = useDispatch();
	const handleFormSubmit = (data) => {
		console.log(data);
		let form = {
			amount: data.amount,
			agent_id: agentId,
		};
		dispatch(addFundAgentDispatch(form, loginInfo));
	};
	return (
		<Formik
			initialValues={{
				amount: '',
			}}
			onSubmit={handleFormSubmit}>
			{(formik) => {
				const { errors, setFieldValue } = formik;
				return (
					<Form>
						<Box style={{}}>
							<Box
								style={{
									padding: 30,
									background: 'white',
								}}>
								<h2>Add Fund</h2>
								<Grid container style={{}} spacing={4}>
									<Grid item xs={12} lg={12}>
										<Field
											name='amount'
											type='number'
											placeHolder='Enter Amount'
											style={{
												padding: 10,
												width: '100%',
												borderRadius: 5,
												border: errors?.amount ? '2px solid red' : '1px solid',
											}}
											inputProps={{
												style: { padding: 12 },
											}}
										/>
										<br />
										{errors?.amount ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors?.amount}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12} lg={3}>
										<Button
											type='submit'
											style={{
												background: 'rgb(25, 118, 210)',
												color: 'white',
												// padding: 16,
												borderRadius: 5,
												width: '100%',
											}}>
											Submit
										</Button>
									</Grid>
								</Grid>
							</Box>
						</Box>
					</Form>
				);
			}}
		</Formik>
	);
};

export default AddFund;
